export default "__VITE_ASSET__ce37aea6__"